var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__wrapper"},[_c('FooterGroups'),_vm._v(" "),_c('FooterCredits'),_vm._v(" "),_c('FooterDocuments'),_vm._v(" "),_c('FooterLicense')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }